import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatSubHeading2]'
})
export class MatSubHeading2Directive {

    @HostBinding('class')
    public class = 'mat-subheading-2';

}
